import apiClient from '../utils/apiClient';

/** Hộp thư + thiết bị đẩy của app On Admin (máy chủ lọc theo app=admin: tin nhóm/kênh Telegram của quản lý). */
export const adminNotificationAPI = {
  list: async (before) => apiClient.get({ url: '/staff-app/notifications', params: { app: 'admin', before } }),

  markRead: async (id) => apiClient.patch({ url: `/staff-app/notifications/${id}/read` }),

  registerDevice: async (token, platform) =>
    apiClient.post({ url: '/staff-app/devices', data: { token, platform, app: 'admin' } }),

  // Truyền thẳng token đăng nhập: lúc đăng xuất token trong localStorage có thể đã bị xoá.
  unregisterDevice: async (token, accessToken) =>
    apiClient.delete({
      url: '/staff-app/devices',
      data: { token },
      headers: { Authorization: `Bearer ${accessToken}` },
    }),
};

export default adminNotificationAPI;
